import {hostedPageType} from "@/utils/post-payment-actions-config";
import LogTracker from "@/utils/log-helper";

export class PostPaymentActionsSubmitter {
  constructor( newCheckoutSubmitter, loadAndSubmitGift, _submitPaynow, paymentHelper ) {
    this.newCheckoutSubmitter = newCheckoutSubmitter;
    this.loadAndSubmitGift = loadAndSubmitGift;
    this._submitPaynow = _submitPaynow
    this.paymentHelper = paymentHelper
  }

  submit(hpType, intent, options = {}, paymentInfo = {}) {
    const {
      data = null,
      pm = null,
      pmType = null,
      replacePrimary = null
    } = options;

    switch (hpType) {
      case hostedPageType.checkoutNew:
        return this.newCheckoutSubmitter().submitCheckoutNew(false, true);
      case hostedPageType.checkoutOnetime:
        return this.newCheckoutSubmitter().submitCheckoutOneTime(false, true);
      case hostedPageType.checkoutExisting:
        return this.newCheckoutSubmitter().submitCheckoutExisting(false, true);
      case hostedPageType.checkoutGift:
        return this.loadAndSubmitGift(false, true);
      case hostedPageType.collectNow:
        return this._submitPaynow(paymentInfo, false, true);
      case hostedPageType.portal:
        return this.paymentHelper.doApiRequest({ data,  pm,  pmType,  replacePrimary, intent }, true);
      default:
        logger.e(new Error(`Unsupported hpType: ${hpType}`))
        return Promise.reject(new Error(`Unsupported hpType: ${hpType}`));
    }
  }

  static kvlPostPaymentActionsLogger(hpType, data, step, store) {
    const systemInfo = new LogTracker(store?.getters, store?.dispatch).getSystemInfo();
    if (hpType === hostedPageType.portal) {
      logger.addMetaData("ssp_token", store?.getters?.sspToken);
    } else {
      logger.addMetaData("hp_token", store?.getters?.hpToken);
    }
    const logPayload = {
      hp_type: hpType,
      time_stamp: Math.floor(Date.now() / 1000),
      step,
      event: 'hpPostPaymentActionsFlow',
      ...systemInfo,
      ...(data.intent?.id && {payment_intent_id: data.intent.id}),
      ...(data.intent?.gateway && {payment_gateway: data.intent.gateway}),
      ...(data.intent?.payment_method_type && {payment_method: data.intent.payment_method_type}),
      ...(data.intent?.status && {status: data.intent.status}),
      ...(data.intent?.active_payment_attempt && {active_payment_attempt: data.intent.active_payment_attempt}),
      ...(data.response?.hp_post_payment_action_id && {hp_post_payment_action_id: data.response.hp_post_payment_action_id}),
      ...(data.redirect_payment_method && {redirect_payment_method: data.redirect_payment_method}),
    };
    logger.kvl(logPayload);
  }
}
